import { render, staticRenderFns } from "./UnderwaterInspection.vue?vue&type=template&id=1fbb1927&"
import script from "./UnderwaterInspection.vue?vue&type=script&lang=js&"
export * from "./UnderwaterInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports